import { Flex, Modal } from "antd";
import { useState } from "react";

import { CustomTitle } from "../customTitle";
import LanguageRadioGroup from "../language-radio/LanguageRadio";

const LanguagePickerDialog = ({ open, onClose }) => {
  /* dispatch an action */

  /* dispatch an action */

  /* loading dependencies */
  const [loading] = useState(false);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          Change Language
        </CustomTitle>
        <LanguageRadioGroup width={"10px"} height={"10px"} />
      </Flex>
    </Modal>
  );
};

export default LanguagePickerDialog;
